<script>
  export let className = "";
  export let height = 1;
  export let title = "University";
</script>

<svg
  class="{className}"
  height="{`${height}em`}"
  viewBox="0 0 20 20"
  focusable="false"
  role="img"
  aria-hidden="true"
>
  <path
    d="M0 6l10-6 10 6v2H0V6zm0 12h20v2H0v-2zm2-2h16v2H2v-2zm0-8h4v8H2V8zm6
    0h4v8H8V8zm6 0h4v8h-4V8z"
  ></path>
</svg>
<span class="visually-hidden">{title}</span>
